<template>
  <div
    class="land-card"
    :class="{ selected: info.select, disabled: info.selectableFlag }"
  >
    <div class="land-name">{{ info.landName }}</div>
    <div class="description">
      <span class="area">{{ info.statisticsLandAcre }}亩</span
      ><span class="group">{{ info.landGroupName }}</span>
    </div>
    <div
      class="crop-info"
      :class="!info.selectableFlag ? '' : 'crop-info-disable'"
    >
      <el-tooltip placement="bottom">
        <div slot="content" v-for="(i, m) in info.cropList" :key="m">
          {{ i.cropBreed ? i.cropName + "-" + i.cropBreed : i.cropName }}：
          {{ i.plantStartDate | formatDate("yyyy-MM-dd") }}
          {{
            i.cropSubjectIdentifier == "agri" ||
            i.cropSubjectIdentifier == "forestry"
              ? "种植"
              : "养殖"
          }}
        </div>
        <div class="name" v-if="info.cropList.length">
          <span v-for="(item, index) in info.cropList" :key="index">
            {{
              item.cropBreed
                ? item.cropName + "-" + item.cropBreed
                : item.cropName
            }}
            <i>、</i>
          </span>
        </div>
      </el-tooltip>

      <div class="no-name" v-if="!info.cropList.length">未种养</div>
      <div v-if="info.selectableFlag" class="tips">
        该地块已申报，不可重复申报
      </div>
    </div>
    <div v-if="info.select" class="selected-status">
      <i class="iconfont icon-gou1"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.land-card {
  position: relative;
  width: 364px;
  height: 107px;
  box-sizing: border-box;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0px 5px 20px rgba(85, 85, 124, 0.13);
  border-radius: 20px;
  border: 1px solid transparent;
  margin: 0 24px 24px 0;
  cursor: pointer;
  overflow: hidden;
  &:nth-child(3n) {
    margin-right: 0;
  }
  &:hover {
    box-shadow: 0px 5px 20px rgba(100, 195, 164, 0.2);
  }
  .land-name {
    width: 285px;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #333333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .description {
    font-size: 12px;
    margin-top: 4px;
    .area {
      color: #b2b2b2;
      margin-right: 12px;
    }
    .group {
      color: #888888;
    }
  }
  .crop-info {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: 12px;
    .name {
      display: inline-block;
      box-sizing: border-box;
      max-width: 160px;
      padding: 3px 9px;
      color: #ff831e;
      font-size: 12px;
      background: #fff2e8;
      border-radius: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      span:last-child i {
        display: none;
      }
    }

    .tips {
      font-size: 12px;
      line-height: 14px;
      color: #ff831e;
    }
  }
  .selected-status {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 0;
    height: 0;
    border: 28px solid transparent;
    border-right: 28px solid #64c3a4;
    border-bottom: 28px solid #64c3a4;
    .iconfont {
      color: #fff;
      font-size: 18px;
      position: absolute;
      top: -1px;
      left: 3px;
    }
  }

  &.selected {
    border: 1px solid $--color-primary;
  }

  &.disabled {
    cursor: not-allowed;
    .land-name {
      color: #cccccc;
    }
    .description {
      opacity: 0.5;
    }
    .crop-info-disable {
      .name {
        background: #f7f9fb;
        color: #cccccc;
      }
    }
  }
  .no-name {
    background: #f7f9fb;
    font-size: 12px;
    padding: 3px 9px;
    border-radius: 10px;
    color: #cccccc;
  }
}
</style>
